import { AmmunitionStockEventSearchComponentBase } from './ammunition-stock-event-search.component.base';
import { Component, Injector, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CrudCommentsDialogConfig, CrudCommentsDialogResults, CrudDataSource, FilteredArrayDataSource, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AMMUNITION_STOCK_TYPE, AmmunitionStock, AmmunitionStockEvent } from 'assets-model';
import { AmmunitionStockEventService, AmmunitionStockService, RangerService } from 'assets-service';
import { openJustfoneDataTransferDialog } from '../../datatransfer/dialog/justfone-data-transfer-dialog.component';

@Component({
  selector: 'app-ammunition-stock-event-search',
  templateUrl: './ammunition-stock-event-search.component.html',
  styleUrls: ['./ammunition-stock-event-search.component.scss']
})
export class AmmunitionStockEventSearchComponent extends AmmunitionStockEventSearchComponentBase {


  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected ammunitionStockEventService: AmmunitionStockEventService,
    protected ammunitionStockService: AmmunitionStockService,
    protected rangerService: RangerService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, ammunitionStockEventService, ammunitionStockService, rangerService, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  ammunitionStockDisplay(item: AmmunitionStock) {
    if (item == null) {
      return "";
    }
    if (typeof item == 'string') {
      return item;
    }
    return AMMUNITION_STOCK_TYPE.description(item);
  }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}

@Component({
  selector: 'app-ammunition-stock-event-history',
  templateUrl: './ammunition-stock-event-history.component.html',
  styleUrls: ['./ammunition-stock-event-search.component.scss']
})
export class AmmunitionStockEventHistoryComponent extends AmmunitionStockEventSearchComponentBase {

  displayedColumns: string[] = ['ammunitionStockEventId', 'ammunitionStock.ammunitionStockId', 'eventDate', 'ammunitionStockDescription', 'ammunitionStockEventType', 'quantity', 'ranger.rangerId', 'acknowledged', 'dateAcknowledged', 'comments', 'createdBy', 'createdDate', 'actions'];
  rangerHistoryDisabledColumns: string[] = ['ranger.rangerId', 'acknowledged'];
  ammunitionStockHistoryDisabledColumns: string[] = ['ammunitionStockDescription', 'acknowledged', 'dateAcknowledged'];
  disabledColumns: string[] = ['ammunitionStockEventId', 'ammunitionStock.ammunitionStockId'];


  @ViewChild("ammunitionStockEventTypeFilterSelectInput") ammunitionStockEventTypeFilterSelectInput: MatSelect;

  get rangerId() {
    return this.routeParams.rangerId;
  }

  get isRangerHistoryMode() {
    return this.routeParams.rangerId != null;
  }

  get ammunitionStockId() {
    return this.routeParams.ammunitionStockId;
  }

  get isAmmunitionStockHistoryMode() {
    return this.routeParams.ammunitionStockId != null;
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected ammunitionStockEventService: AmmunitionStockEventService,
    protected ammunitionStockService: AmmunitionStockService,
    protected rangerService: RangerService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, ammunitionStockEventService, ammunitionStockService, rangerService, fb, formStorage, injector);
  }


  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
    if (this.isRangerHistoryMode) {
      this.ammunitionStockEventType.disable();
    }
    if (this.isAmmunitionStockHistoryMode) {
      this.ammunitionStockEventType.enable();
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.columns.$afterViewInit.subscribe(data => {
      this.setDisplayColumnsForContext();
    });

  }

  ngAfterViewInit(): void {
    this.addSearchOnChangedSelectEventListener(this.ammunitionStockEventTypeFilterSelectInput);
    this.sort.sort({ id: 'eventDate', start: 'asc', disableClear: true });
    super.ngAfterViewInit();
  }

  private setDisplayColumnsForContext() {
    if (!this.columns) {
      return;
    }
    var disabledColumns = [...this.disabledColumns];
    if (this.isRangerHistoryMode) {
      disabledColumns = disabledColumns.concat(this.rangerHistoryDisabledColumns);
    } else {
      disabledColumns = disabledColumns.concat(this.ammunitionStockHistoryDisabledColumns);
    }
    this.columns.setColumnsEnabled(disabledColumns, false);
  
    // reset the defaults for the context so the picker Reset button doesn't re-enable the columns above
    this.columns.resetInitialDisplayColumns();
  }

  createServiceArguments(): any {
    var args = super.createServiceArguments();
    if (this.isAmmunitionStockHistoryMode) {
      args.ammunitionStockId = this.routeParams.ammunitionStockId;
    }
    if (this.isRangerHistoryMode) {
      args.rangerId = this.routeParams.rangerId;
    }
    return args;
  }

  getEditorTitle() {
    return this.isRangerHistoryMode ? ("Ammunition Issue History - Ranger ID " + this.rangerId) : ("Ammunition Stock History - ID " + this.ammunitionStockId);
  }

  allowsCreate(): boolean {
    return false;
  }

  allowsEdit(item: AmmunitionStockEvent): boolean {
    return false;
  }

  allowsDelete(item: AmmunitionStockEvent): boolean {
    return false;
  }

  allowsAcknowledge(item: AmmunitionStockEvent): boolean {
    return !item.acknowledged && this.userStorage.currentUserHasAnyAuthority("ACTS_AT_NATIONAL_LEVEL");
  }

  acknowledgeManual(item: AmmunitionStockEvent) {
    this.openSimpleConfirmationDialog('Are you sure you want to acknowledge this ' + item.ammunitionStockEventType + ' on behalf of the ranger?', 'Acknowledge Ammunition Stock ' + item.ammunitionStockEventType, 'Acknowledge').afterClosed().subscribe(result => {
      if (result) {
        this.ammunitionStockEventService.acknowledgeManual(item.ammunitionStockEventId).subscribe(
          data => {
            this.snackbar.open(item.ammunitionStockEventType +' Acknowledged', 'OK', { duration: 3000 });
            this.forceSearch();
          }
        );
      }
    });    
  }

  allowsView(item: AmmunitionStockEvent): boolean {
    return false;
  }

  allowsJustfoneDebug(item?: AmmunitionStockEvent): boolean {
    return this.userStorage.currentUserHasAnyAuthority("IS_SUPERUSER");
  }

  openJustfoneDebugDialog(item: AmmunitionStockEvent) {
    openJustfoneDataTransferDialog(this.dialog, 'AmmunitionStockEvent', item.ammunitionStockEventId);
  }

  editComments(element: AmmunitionStockEvent) {
    const dialogConfig = <CrudCommentsDialogConfig>{
      title: "Edit Comments",
      maxLength: 255,
      comments: element.comments,
      readOnly: false,
    }
    this.openCrudCommentsDialog(dialogConfig).afterClosed().subscribe(
      (data: CrudCommentsDialogResults) => {
        if (data.changed) {
          element.comments = data.comments;
          this.ammunitionStockEventService.save(element).subscribe(
            data => {
              this.snackbar.open("Comment Saved");
            }
          )
        }
      }
    )
  }

  allowsEditComments(){
    return this.userStorage.currentUserHasAnyAuthority("ACTS_AT_NATIONAL_LEVEL")
  }
  
  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}

@Component({
  selector: 'app-ammunition-stock-event-list',
  templateUrl: './ammunition-stock-event-list.component.html',
  styleUrls: ['./ammunition-stock-event-search.component.scss']
})
export class AmmunitionStockEventListComponent extends AmmunitionStockEventSearchComponentBase {

  displayedColumns: string[] = ['ammunitionStockEventId', 'ammunitionStock.ammunitionStockId', 'ammunitionStockEventType', 'quantity', 'ranger.rangerId', 'comments', 'eventDate', 'createdDate', 'createdBy', 'actions'];

  disabledColumns: string[] = ['ammunitionStockEventId', 'ammunitionStock.ammunitionStockId', 'actions'];

  ammuntionStockEventList: AmmunitionStockEvent[] = [];

  @Input()
  ammunitionStockParent: AmmunitionStock;

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected ammunitionStockEventService: AmmunitionStockEventService,
    protected ammunitionStockService: AmmunitionStockService,
    protected rangerService: RangerService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, ammunitionStockEventService, ammunitionStockService, rangerService, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }
  @Input()
  set items(v: AmmunitionStockEvent[]) {
    this.ammuntionStockEventList = v;
  }
  get items(): AmmunitionStockEvent[] {
    return this.ammuntionStockEventList;
  }

  // createDataSource(): CrudDataSource<AmmunitionStockEvent> {
  //   return this.ammuntionStockEventListDataSource;
  // }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

  allowsCreate(): boolean {
    return false;
  }
  allowsBack(): boolean {
    return false;
  }
  allowsDelete(item: AmmunitionStockEvent): boolean {
    return false;
  }
  allowsEdit(item: AmmunitionStockEvent): boolean {
    return false;
  }
  allowsView(item: AmmunitionStockEvent): boolean {
    return false;
  }

  eventTypeClass(element: AmmunitionStockEvent) {
    return {
      'issue-cell': element.ammunitionStockEventType == 'Issue',
      'stocktake-cell': element.ammunitionStockEventType == 'Stocktake',
      'addition-cell': element.ammunitionStockEventType == 'Addition',
      'return-cell': element.ammunitionStockEventType == 'Return'
    };
  }
}

